import timeDepositConstants from '../actiontypes/timeDeposit';

const initialState = {
  completed: false,
  account: '',
  timeDepositLiquidate: {}
};

function liquidate(state = initialState, action) {
  switch (action.type) {
    case timeDepositConstants.LIQUIDATE_REQUEST:
      return { ...state };
    case timeDepositConstants.LIQUIDATE_SUCCESS:
      return {
        ...state,
        completed: true,
        timeDepositLiquidate: action.payload
      };
    case timeDepositConstants.LIQUIDATE_FAILURE:
      return { ...state, completed: false, timeDepositLiquidate: {} };
    case timeDepositConstants.LIQUIDATE_ACCOUNT_CHANGED:
      return { ...state, account: action.payload };
    case timeDepositConstants.LIQUIDATE_CLEANED:
      return initialState;
    default:
      return state;
  }
}

export default liquidate;
